export const invoicesNational = {
	title: "Notas Fiscais",
	description:
		"Download individual ou grupo de Notas fiscais emitidas no periodo selecionado.",
	acitons: {
		exportToExcel: "Exportar para excel",
		downloadXml: "Download de XML",
	},
	filters: {
		fiscalProfileLabel: "Perfil fiscal",
		invoiceNumberLabel: "Número de nota",
		invoiceNumberPlaceholder: "Busca por número de nota",
		rangePickerLabel: "Período de emissão",
		statusLabel: "Status",
		allInvoices: "Todas as notas fiscais",
		canceledInvoices: "Notas fiscais canceladas",
	},
	table: {
		issuedAt: "Emitida em",
		mode: "Modo de emissão",
		createdBy: "Funcionário",
		fiscalProfile: "Perfil fiscal",
		eventDate: "Data do evento",
		isCanceled: "Cancelada",
		serie: "Série nota",
		num: "Nº nota",
		value: "Valor nota",
		actions: "Ações",
		downloadInvoice: {
			download: "Baixar",
			pdf: "PDF",
			image: "Imagem",
			xml: "XML",
			cancelXml: "XML de cancelamento",
		},
		cancelInvoice: {
			yesCancel: "Sim, cancelar nota fiscal",
			confirm: "ok",
			areYouSure: "Tem certeza que deseja cancelar a nota fiscal?",
			timeLimitExplanation:
				"Notas emitidas a mais de 30 minutos não podem ser canceladas",
			cancel: "Cancelar",
		},
		paginationTotal: " de {{total}}",
	},
};
